import { IconAddPerson } from './icons/AddPerson';
import { IconArchive } from './icons/Archive';
import { IconArm } from './icons/Arm';
import { IconAvatar } from './icons/Avatar';
import { IconBall } from './icons/Ball';
import { IconBatteryCritical } from './icons/BatteryCritical';
import { IconBatteryFull } from './icons/BatteryFull';
import { IconBatteryWarning } from './icons/BatteryWarning';
import { IconCalendar } from './icons/Calendar';
import { IconChart } from './icons/Chart';
import { IconCheckmark } from './icons/Checkmark';
import { IconChevron } from './icons/Chevron';
import { IconClock } from './icons/Clock';
import { IconCross } from './icons/Cross';
import { IconCrossCircle } from './icons/CrossCircle';
import { IconDelete } from './icons/Delete';
import { IconDocument } from './icons/Document';
import { IconEdit } from './icons/Edit';
import { IconEducation } from './icons/Education';
import { IconError } from './icons/Error';
import { IconFile } from './icons/File';
import { IconHome } from './icons/Home';
import { IconBulb } from './icons/IconBulb';
import { IconInfo } from './icons/Info';
import { IconLanguage } from './icons/Language';
import { IconMenu } from './icons/Menu';
import { IconNewFile } from './icons/NewFile';
import { IconORYXGO } from './icons/ORYXGO';
import { IconPerson } from './icons/Person';
import { IconPlus } from './icons/Plus';
import { IconReset } from './icons/Reset';
import { IconRun } from './icons/Run';
import { IconSearch } from './icons/Search';
import { IconSettings } from './icons/Settings';
import { IconSingleLegSquat } from './icons/SingleLegSquat';
import { IconSliders } from './icons/Sliders';
import { IconSpinner } from './icons/Spinner';
import { IconSquat } from './icons/Squat';
import { IconTag } from './icons/Tag';
import { IconTest } from './icons/Test';
import { IconUndo } from './icons/Undo';
import { IconUpload } from './icons/Upload';
import { IconUser } from './icons/User';
import { IconWalk } from './icons/Walk';

export enum IconRotate {
  North = '180deg',
  NorthEast = '-135deg',
  NorthWest = '135deg',
  East = '-90deg',
  South = '0deg',
  SouthEast = '-45deg',
  SouthWest = '45deg',
  West = '90deg',
}

export enum IconSize {
  extraSmall = 10,
  small = 14,
  medium = 16,
  large = 18,
  extraLarge = 20,
  extraExtraLarge = 128,
}

export const iconComponents = {
  addPerson: IconAddPerson,
  archive: IconArchive,
  arm: IconArm,
  avatar: IconAvatar,
  ball: IconBall,
  batteryCritical: IconBatteryCritical,
  batteryFull: IconBatteryFull,
  batteryWarning: IconBatteryWarning,
  calendar: IconCalendar,
  chart: IconChart,
  checkmark: IconCheckmark,
  chevron: IconChevron,
  clock: IconClock,
  'cross-circle': IconCrossCircle,
  cross: IconCross,
  delete: IconDelete,
  document: IconDocument,
  edit: IconEdit,
  education: IconEducation,
  error: IconError,
  file: IconFile,
  home: IconHome,
  info: IconInfo,
  language: IconLanguage,
  menu: IconMenu,
  newFile: IconNewFile,
  oryxgo: IconORYXGO,
  person: IconPerson,
  plus: IconPlus,
  reset: IconReset,
  search: IconSearch,
  settings: IconSettings,
  sliders: IconSliders,
  spinner: IconSpinner,
  tag: IconTag,
  test: IconTest,
  upload: IconUpload,
  user: IconUser,
  walk: IconWalk,
  run: IconRun,
  singleLegSquat: IconSingleLegSquat,
  squat: IconSquat,
  undo: IconUndo,
  bulb: IconBulb,
};
